import React from "react";
import { IconButton, useTheme } from "@mui/material";
import LocationOnIcon from "@mui/icons-material/LocationOn";
import { useFormContext } from "../../../../common/contexts/FormContext";
import "./CurrentLocation.css";
import apiConfig, { revGeoCodeKey } from "../../../../service/apiConfig";

import axios from "axios";

interface CurrentLocationProps {
  label?: string;
}
const CurrentLocation: React.FC<CurrentLocationProps> = ({ label }) => {
  const theme = useTheme();
  const { setFormValues } = useFormContext();

  const getCurrentLocation = () => {
    const controller = new AbortController();
    const { signal } = controller;
    if (navigator.geolocation) {
      navigator.geolocation.getCurrentPosition(async (position) => {
        const { latitude, longitude } = position.coords;
        try {
          const apiKey =
            revGeoCodeKey[process.env.development || "development"];
          const url = `${apiConfig.revGeoCodeApi}${latitude}%2C${longitude}&lang=en-US&apikey=${apiKey}`;
          const response = await axios.get(url, { signal });
          if (response?.data) {
            const data = response.data?.items[0];
            let postalCode = data?.address?.postalCode;
            if (postalCode) {
              // If postal code contains a hyphen (e.g. "27597-5750"), keep only the part before the hyphen
              if (postalCode.includes("-")) {
                postalCode = postalCode.split("-")[0];
              }
              setFormValues((prevValues) => ({
                ...prevValues,
                zipcode: postalCode,
              }));
            }
          }
        } catch (error) {
          console.error("Error fetching location data:", error);
        }
      });
    } else {
      console.error("Geolocation is not supported by this browser.");
    }
  };

  return (
    <div>
      <IconButton
        className="use-my-location"
        sx={{
          p: "10px",
          backgroundColor: theme.palette.secondary.dark,
          "&:hover": {
            backgroundColor: theme.palette.secondary.dark,
          },
        }}
        onClick={getCurrentLocation}
      >
        <LocationOnIcon className="location-icon" />
        {label}
      </IconButton>
    </div>
  );
};

export default CurrentLocation;
